import Img1 from "../../../assets/images/accom/new-image.jpeg";
import Img2 from "../../../assets/images/accom/new-image-last.jpeg";

import Img3 from "../../../assets/images/accom/Image_3.webp";
import Img4 from "../../../assets/images/accom/new-image-4.jpeg";
import { useLocation } from "react-router-dom";
import { getAccommodationText } from "..";

const AccommodationPhotos = () => {
  const { pathname } = useLocation();
  return (
    <div className=" flex flex-col item item w-full mx-auto">
      <div className="flex w-full justify-between">
        <div className="flex w-full flex-col lg:flex-row gap-5 items-center">
          <div className="w-full font-normal lg:text-[40px] text-[22px] md:text-28">
            {getAccommodationText("privacyNote")}
          </div>
          <div className="flex flex-col gap-6">
            <div className="text-[#7A7A7A] text-[18px] md:text-[22px] font-medium">
              {" "}
              {getAccommodationText("teamReady")}
            </div>
            <a href={`${pathname}/about`}>
              <div className="text-18 font-semibold flex gap-2">
                {getAccommodationText("moreInfo")}
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M18.7504 6V15.75C18.7504 15.9489 18.6714 16.1397 18.5307 16.2803C18.3901 16.421 18.1993 16.5 18.0004 16.5C17.8015 16.5 17.6107 16.421 17.4701 16.2803C17.3294 16.1397 17.2504 15.9489 17.2504 15.75V7.81031L6.53104 18.5306C6.39031 18.6714 6.19944 18.7504 6.00042 18.7504C5.80139 18.7504 5.61052 18.6714 5.46979 18.5306C5.32906 18.3899 5.25 18.199 5.25 18C5.25 17.801 5.32906 17.6101 5.46979 17.4694L16.1901 6.75H8.25042C8.0515 6.75 7.86074 6.67098 7.72009 6.53033C7.57943 6.38968 7.50042 6.19891 7.50042 6C7.50042 5.80109 7.57943 5.61032 7.72009 5.46967C7.86074 5.32902 8.0515 5.25 8.25042 5.25H18.0004C18.1993 5.25 18.3901 5.32902 18.5307 5.46967C18.6714 5.61032 18.7504 5.80109 18.7504 6Z"
                    fill="#191818"
                  />
                </svg>
              </div>
            </a>
          </div>
        </div>
      </div>
      <div className="flex justify-between gap-3 lg:mt-14 mt-8 w-full">
        <div className="flex justify-between w-full flex-col lg:flex-row gap-5">
          <div className=" row-span-2 w-full">
            <img
              className=" lg:h-[693px] max-w-full w-full rounded-[20px]"
              src={Img1}
              alt={``}
            />
          </div>
          <div className="flex flex-col gap-5 w-full">
            <div>
              <img
                className="h-[293px] max-w-full w-full rounded-[20px]"
                src={Img3}
                alt={``}
              />
            </div>
            <div>
              <img
                className="h-[388px] max-w-full w-full rounded-[20px]"
                src={Img4}
                alt={``}
              />
            </div>
          </div>
          <div className=" row-span-2 w-full">
            <img
              className=" lg:h-[693px] max-w-full w-full rounded-[20px]"
              src={Img2}
              alt={``}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccommodationPhotos;
